import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "./config/API";

function ForgotPassword() {
  const navigate = useNavigate();

  //=========================================
  // States
  //=========================================

  const [method, setMethod] = useState("mobile");

  const [loading, setLoading] = useState(false);

  const [otpSent, setOtpSent] = useState(false);

  const [message, setMessage] = useState("");

  const [messageType, setMessageType] = useState("");

  const [errors, setErrors] = useState({});

  const [seconds, setSeconds] = useState(100);

  const [timerRunning, setTimerRunning] = useState(false);

  const [form, setForm] = useState({
    emailId: "",

    mobileNumber: "",

    otp: "",
  });

  //=========================================
  // Timer
  //=========================================

  useEffect(() => {
    let interval = null;

    if (timerRunning && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    if (seconds === 0) {
      setTimerRunning(false);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [timerRunning, seconds]);

  //=========================================
  // Input Change
  //=========================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const mobile = value.replace(/\D/g, "").slice(0, 10);

      setForm((prev) => ({
        ...prev,

        mobileNumber: mobile,
      }));

      return;
    }

    if (name === "otp") {
      const otp = value.replace(/\D/g, "").slice(0, 6);

      setForm((prev) => ({
        ...prev,

        otp,
      }));

      return;
    }

    setForm((prev) => ({
      ...prev,

      [name]: value,
    }));
  };

  //=========================================
  // Reset Form
  //=========================================

  const resetForm = () => {
    setErrors({});

    setMessage("");

    setMessageType("");

    setOtpSent(false);

    setTimerRunning(false);

    setSeconds(100);

    setForm({
      emailId: "",

      mobileNumber: "",

      otp: "",
    });
  };

  //=========================================
  // Validation
  //=========================================

  const validateSendOtp = () => {
    let err = {};

    if (method === "email") {
      if (!form.emailId.trim()) {
        err.emailId = "Email Address is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.emailId)) {
        err.emailId = "Enter valid Email Address";
      }
    }

    if (method === "mobile") {
      if (!form.mobileNumber) {
        err.mobileNumber = "Mobile Number is required";
      } else if (!/^[6-9][0-9]{9}$/.test(form.mobileNumber)) {
        err.mobileNumber = "Enter valid Mobile Number";
      }
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  const validateOtp = () => {
    let err = {};

    if (!form.otp) {
      err.otp = "OTP is required";
    } else if (!/^[0-9]{6}$/.test(form.otp)) {
      err.otp = "OTP must be 6 digits";
    }

    setErrors(err);

    return Object.keys(err).length === 0;
  };

  //=========================================
  // Format Timer
  //=========================================

  const formatTime = () => {
    const min = Math.floor(seconds / 60);

    const sec = seconds % 60;

    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  //=========================================
  // Part-2 Starts Here
  // sendOtp()
  // submitOtp()
  // resendOtp()
  //=========================================
  //=========================================
  // SEND OTP
  //=========================================

  const sendOtp = async () => {
    if (!validateSendOtp()) return;

    setLoading(true);

    setMessage("");

    setMessageType("");

    try {
      const payload = {
        emailId: method === "email" ? form.emailId.trim() : null,

        mobileNumber: method === "mobile" ? Number(form.mobileNumber) : null,

        otp: null,
      };

      const response = await fetch(`${API.V2}/pgOwner/forgotPasswordOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const res = await response.json();

      if (response.ok || res.statusCode === 200) {
        setOtpSent(true);

        setSeconds(100);

        setTimerRunning(true);

        setMessageType("success");

        setMessage(res.message || "OTP sent successfully.");
      } else {
        setMessageType("error");

        setMessage(res.message || "Unable to send OTP.");
      }
    } catch (e) {
      console.error(e);

      setMessageType("error");

      setMessage("Server not reachable.");
    } finally {
      setLoading(false);
    }
  };

  //=========================================
  // SUBMIT OTP
  //=========================================

  const submitOtp = async () => {
    if (!validateOtp()) return;

    setLoading(true);

    setMessage("");

    setMessageType("");

    try {
      const payload = {
        emailId: method === "email" ? form.emailId.trim() : null,

        mobileNumber: method === "mobile" ? Number(form.mobileNumber) : null,

        otp: Number(form.otp),
      };

      const response = await fetch(`${API.V2}/pgOwner/forgotPasswordOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const res = await response.json();

      if (response.ok || res.statusCode === 200) {
        setMessageType("success");

        setMessage(res.message);

        setTimeout(() => {
          navigate("/changePassword", {
            state: {
              emailId: form.emailId,

              mobileNumber: form.mobileNumber,
            },
          });
        }, 1000);
      } else {
        setMessageType("error");

        setMessage(res.message || "Invalid OTP");
      }
    } catch (e) {
      console.error(e);

      setMessageType("error");

      setMessage("Server not reachable.");
    } finally {
      setLoading(false);
    }
  };

  //=========================================
  // RESEND OTP
  //=========================================

  const resendOtp = () => {
    if (timerRunning) {
      return;
    }

    sendOtp();
  };

  //=========================================
  // Change Recovery Method
  //=========================================

  //=========================================
  // Part-3 Starts Here
  // return(
  //=========================================
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Forgot Password</h2>

        <p style={styles.subTitle}>
          Enter your registered Mobile Number or Email Address to receive an
          OTP.
        </p>

        {/* ===================== MESSAGE ===================== */}

        {message && (
          <div
            style={{
              ...styles.message,
              backgroundColor:
                messageType === "success" ? "#e8f5e9" : "#ffebee",
              color: messageType === "success" ? "#2e7d32" : "#c62828",
              border:
                messageType === "success"
                  ? "1px solid #81c784"
                  : "1px solid #ef9a9a",
            }}
          >
            {message}
          </div>
        )}

        {/* ===================== SELECT OPTION ===================== */}

        <div style={styles.radioContainer}>
          <label>
            <input
              type="radio"
              checked={method === "mobile"}
              onChange={() => {
                setMethod("mobile");
                resetForm();
              }}
            />
            Registered Mobile Number
          </label>

          <label>
            <input
              type="radio"
              checked={method === "email"}
              onChange={() => {
                setMethod("email");
                resetForm();
              }}
            />
            Registered Email Address
          </label>
        </div>

        {/* ===================== MOBILE ===================== */}

        {method === "mobile" && (
          <div style={styles.field}>
            <label style={styles.label}>Registered Mobile Number</label>

            <input
              type="text"
              name="mobileNumber"
              placeholder="Enter Registered Mobile Number"
              value={form.mobileNumber}
              onChange={handleChange}
              maxLength={10}
              style={styles.input}
              disabled={otpSent}
            />

            {errors.mobileNumber && (
              <span style={styles.error}>{errors.mobileNumber}</span>
            )}
          </div>
        )}
        {/* ===================== EMAIL ===================== */}

        {method === "email" && (
          <div style={styles.field}>
            <label style={styles.label}>Registered Email Address</label>

            <input
              type="email"
              name="emailId"
              placeholder="Enter Registered Email Address"
              value={form.emailId}
              onChange={handleChange}
              style={styles.input}
              disabled={otpSent}
            />

            {errors.emailId && (
              <span style={styles.error}>{errors.emailId}</span>
            )}
          </div>
        )}

        {/* ===================== SEND OTP ===================== */}

        {!otpSent && (
          <button
            onClick={sendOtp}
            disabled={loading}
            style={styles.primaryButton}
          >
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        )}

        {/* ===================== OTP SECTION ===================== */}

        {otpSent && (
          <>
            <div style={styles.field}>
              <label style={styles.label}>Enter OTP</label>

              <input
                type="text"
                name="otp"
                value={form.otp}
                onChange={handleChange}
                maxLength={6}
                placeholder="Enter 6 Digit OTP"
                style={styles.input}
              />

              {errors.otp && <span style={styles.error}>{errors.otp}</span>}
            </div>

            {/* TIMER */}

            <div style={styles.timerBox}>
              {timerRunning ? (
                <span style={styles.timer}>OTP expires in {formatTime()}</span>
              ) : (
                <span
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                >
                  OTP Expired
                </span>
              )}
            </div>

            {/* SUBMIT */}

            <button
              style={styles.successButton}
              onClick={submitOtp}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Submit OTP"}
            </button>

            {/* RESEND */}

            <button
              style={{
                ...styles.outlineButton,
                opacity: timerRunning ? 0.5 : 1,
                cursor: timerRunning ? "not-allowed" : "pointer",
              }}
              disabled={timerRunning || loading}
              onClick={resendOtp}
            >
              {timerRunning ? `Resend OTP (${formatTime()})` : "Resend OTP"}
            </button>
          </>
        )}

        {/* ===================== LOGIN ===================== */}

        <div style={styles.footer}>
          <span style={styles.loginLink} onClick={() => navigate("/")}>
            ← Back to Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg,#E3F2FD,#F5F7FA)",
    padding: "20px",
    fontFamily: "'Segoe UI', sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "480px",
    background: "#fff",
    borderRadius: "15px",
    padding: "35px",
    boxShadow: "0 10px 35px rgba(0,0,0,0.12)",
  },

  title: {
    margin: 0,
    textAlign: "center",
    color: "#1565C0",
    fontSize: "30px",
    fontWeight: "700",
  },

  subTitle: {
    marginTop: "10px",
    marginBottom: "25px",
    textAlign: "center",
    color: "#666",
    fontSize: "15px",
    lineHeight: "24px",
  },

  message: {
    padding: "12px",
    borderRadius: "8px",
    marginBottom: "20px",
    textAlign: "center",
    fontWeight: "600",
  },

  radioContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "25px",
    gap: "20px",
  },

  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
    cursor: "pointer",
    color: "#37474F",
  },

  field: {
    marginBottom: "20px",
  },

  label: {
    display: "block",
    marginBottom: "8px",
    color: "#37474F",
    fontWeight: "600",
    fontSize: "14px",
  },

  input: {
    width: "100%",
    padding: "13px 15px",
    border: "1px solid #CFD8DC",
    borderRadius: "8px",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
    transition: "0.3s",
  },

  error: {
    color: "#D32F2F",
    fontSize: "12px",
    marginTop: "6px",
    display: "block",
    fontWeight: "600",
  },

  timerBox: {
    textAlign: "center",
    marginBottom: "18px",
  },

  timer: {
    color: "#1565C0",
    fontWeight: "700",
    fontSize: "15px",
  },

  primaryButton: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    background: "#1976D2",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "10px",
    transition: "0.3s",
  },

  successButton: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    background: "#2E7D32",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    marginBottom: "15px",
    transition: "0.3s",
  },

  outlineButton: {
    width: "100%",
    padding: "14px",
    borderRadius: "8px",
    border: "2px solid #1976D2",
    background: "#fff",
    color: "#1976D2",
    fontWeight: "700",
    fontSize: "15px",
    cursor: "pointer",
    transition: "0.3s",
  },

  footer: {
    marginTop: "30px",
    textAlign: "center",
  },

  loginLink: {
    color: "#1976D2",
    cursor: "pointer",
    fontWeight: "700",
    textDecoration: "none",
    fontSize: "15px",
  },
};
